/**
 * Easy Bundle Builder looks for third-party slide-cart APIs after ATC.
 * Horizon uses <theme-drawer id="cart-drawer"> instead — expose the hooks
 * the app already calls so the theme cart refreshes and opens.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

/** @returns {HTMLElement & { open?: () => void } | null} */
function getCartDrawer() {
  return document.querySelector('theme-drawer#cart-drawer');
}

function openThemeCart() {
  const drawer = getCartDrawer();

  if (typeof drawer?.open === 'function') {
    drawer.open();
    return;
  }

  window.Shopify?.actions?.openCart?.();
}

function refreshThemeCart() {
  const deferredEventPromise = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'dialog',
      lines: [{ merchandiseId: 'gid://shopify/ProductVariant/0', quantity: 1 }],
      promise: deferredEventPromise.promise,
    })
  );

  const cartUrl = Theme.routes.cart_url || '/cart';

  fetch(`${cartUrl}.json`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
      return response.json();
    })
    .then((ajaxCart) => {
      deferredEventPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          itemCount: ajaxCart.item_count,
          source: 'easy-bundle-builder',
          didError: false,
        },
      });
    })
    .catch((error) => {
      deferredEventPromise.reject(error);
      console.warn('[easy-bundle-builder] Failed to refresh cart', error);
    });
}

window.SLIDECART_UPDATE = refreshThemeCart;
window.SLIDECART_OPEN = openThemeCart;
